import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router-dom";

import AppSidebarV2 from "../components/layout/AppSidebarV2";
import GroupSessions from "../components/groupSessions/GroupSessions";
import { useAuth } from "../auth/authStore";
import { useNotifications } from "../notifications/notificationsStore";

export default function PsychologistGroupSessions() {
  const navigate = useNavigate();
  const location = useLocation();
  const { me, role, logout } = useAuth();
  const { unreadNotificationsCount = 0 } = useNotifications();
  const [mobileSidebarOpen, setMobileSidebarOpen] = React.useState(false);

  const roleCode = String(role || "").toUpperCase();
  const isMySessionsView = location.pathname.startsWith("/dashboard/group-sessions/my");
  const userName = me?.name || me?.fullName || me?.login || me?.email || "Пользователь";
  const roleTitle = roleCode === "CLIENT"
    ? "Клиент"
    : roleCode === "ADMIN"
      ? "Администратор"
      : roleCode === "MODERATOR"
        ? "Модератор"
        : "Психолог";
  const canOpenLiteratureEditor = ["ADMIN", "PSYCHOLOGIST", "MODERATOR"].includes(roleCode);
  const canManageSessions = canOpenLiteratureEditor;

  React.useEffect(() => {
    if (isMySessionsView && !canManageSessions) {
      navigate("/dashboard/group-sessions", { replace: true });
    }
  }, [isMySessionsView, canManageSessions, navigate]);

  const handleLogout = React.useCallback(async () => {
    await logout();
    navigate("/login", { replace: true });
  }, [logout, navigate]);
  const handleBack = React.useCallback(() => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/dashboard", { replace: true });
  }, [navigate]);

  return (
    <div className="psych-dashboard-v2 client-dashboard-v2 podcasts-hub group-sessions-dashboard">
      <Helmet prioritizeSeoTags>
        <title>{isMySessionsView ? "Мои сессии" : "Групповые сессии"} | Бюро Души</title>
        <meta
          name="description"
          content={isMySessionsView ? "Авторизованный раздел для управления собственными групповыми сессиями." : "Авторизованный раздел для просмотра и записи на групповые сессии."}
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="shell shell--shared podcasts-shell">
        <AppSidebarV2
          activeKey="group-sessions"
          mobileOpen={mobileSidebarOpen}
          onCloseMobile={() => setMobileSidebarOpen(false)}
          userName={userName}
          roleLabel={roleTitle}
          canOpenLiteratureEditor={canOpenLiteratureEditor}
          notificationsBadge={unreadNotificationsCount}
          onLogout={handleLogout}
        />

        <button
          className={`podcasts-overlay ${mobileSidebarOpen ? "is-open" : ""}`}
          type="button"
          onClick={() => setMobileSidebarOpen(false)}
          aria-label="Закрыть меню"
        />

        <main className="main podcasts-main cd-main">
          <header className="podcasts-topbar group-sessions-mobile-topbar">
            <div className="podcasts-topbar__left group-sessions-mobile-topbar__left">
              <button
                className="podcasts-topbar__menu-btn group-sessions-mobile-topbar__icon-btn"
                type="button"
                onClick={handleBack}
                aria-label="Назад"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <button
                className="podcasts-topbar__menu-btn group-sessions-mobile-topbar__icon-btn"
                type="button"
                onClick={() => setMobileSidebarOpen(true)}
                aria-label="Открыть меню"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <line x1="3" y1="18" x2="21" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>
              <div className="group-sessions-mobile-topbar__titles">
                <strong>{isMySessionsView ? "Мои сессии" : "Групповые сессии"}</strong>
                <span>{isMySessionsView ? "Управление вашими встречами" : "Каталог и запись"}</span>
              </div>
            </div>
          </header>
          <div className="page">
            <section className="group-sessions-dashboard__section">
              <GroupSessions view={isMySessionsView ? "my" : "catalog"} />
            </section>
          </div>
        </main>
      </div>
    </div>
  );
}
